export const RolloutTargetValue = {
  VALUE: 'value',
  STRING: 'string',
  SCRIPT: 'script',
};
